import { render, staticRenderFns } from "./ImgZoomable.vue?vue&type=template&id=01226d44&scoped=true"
import script from "./ImgZoomable.vue?vue&type=script&lang=js"
export * from "./ImgZoomable.vue?vue&type=script&lang=js"
import style0 from "./ImgZoomable.vue?vue&type=style&index=0&id=01226d44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01226d44",
  null
  
)

export default component.exports